export default "__VITE_ASSET__sNi8xCMV__"